module.exports = __webpack_public_path__ + "img/production.5de3d2e0.jpg";